import { Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { QuotesDashboardComponent } from './pages/quotes-dashboard/quotes-dashboard.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { AgentsDashboardComponent } from './pages/agents-dashboard/agents-dashboard.component';
import {BillsDashboardComponent} from "./pages/bills-dashboard/bills-dashboard.component";
import {BillFormComponent} from "./pages/bills-dashboard/components/bill-form/bill-form.component";
import {DistributionDashboardComponent} from "./pages/distribution-dashboard/distribution-dashboard.component";
import {DashboardComponent} from "./pages/dashboard/dashboard.component";
import {BookOfBusinessComponent} from "./pages/book-of-business/book-of-business.component";

export const routesPaths = {
  login: 'login',
  forgotPassword: 'forgot-password',
  resetPassword: 'reset-password',
  dashboard: 'dashboard',
  quotesDashboard: 'quotes-dashboard',
  agentsDashboard: 'agents-dashboard',
  billsDashboard: 'bills-dashboard',
  distributionDashboard: 'distribution-dashboard',
  bookOfBusiness: 'book',
};

export const unAuthorizedRoutes: string[] = [routesPaths.login, routesPaths.forgotPassword, routesPaths.resetPassword];

export const routes: Routes = [
  {
    path: routesPaths.login,
    title: 'Flexbenefits - Login',
    component: LoginComponent,
  },
  {
    path: routesPaths.forgotPassword,
    title: 'Flexbenefits - Forgot Password',
    component: ForgotPasswordComponent,
  },
  {
    path: `${routesPaths.resetPassword}/:token`,
    title: 'Flexbenefits - Reset Password',
    component: ResetPasswordComponent,
  },
  {
    path: routesPaths.dashboard,
    title: 'Flexbenefits - Dashboard',
    component: DashboardComponent,
  },
  {
    path: routesPaths.quotesDashboard,
    title: 'Flexbenefits - Quotes Dashboard',
    component: QuotesDashboardComponent,
  },
  {
    path: routesPaths.billsDashboard,
    title: 'Flexbenefits - Bills Dashboard',
    component: BillsDashboardComponent,
  },
  {
    path: `${routesPaths.billsDashboard}/create`,
    title: 'Flexbenefits - Create Group List Bill',
    component: BillFormComponent,
  },
  {
    path: `${routesPaths.billsDashboard}/edit/:id`,
    title: 'Flexbenefits - Edit Group List Bill',
    component: BillFormComponent,
  },
  {
    path: routesPaths.agentsDashboard,
    title: 'Flexbenefits - Agents Dashboard',
    component: AgentsDashboardComponent,
  },
  {
    path: routesPaths.distributionDashboard,
    title: 'Flexbenefits - Distribution Dashboard',
    component: DistributionDashboardComponent,
  },
  {
    path: routesPaths.bookOfBusiness,
    title: 'Flexbenefits - Book of Business',
    component: BookOfBusinessComponent,
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];
